
import React from 'react';
import Layout from '@/components/Layout';
import AuthenticationPage from '@/components/Profile/AuthenticationPage';
import ProfileHeader from '@/components/Profile/ProfileHeader';
import ProfileContent from '@/components/Profile/ProfileContent';
import { useAuth } from '@/contexts/AuthContext';

const Profile = () => {
  const { user, loading } = useAuth();
  
  return (
    <Layout>
      <div className="min-h-screen">
        <ProfileHeader />
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
          </div>
        ) : (
          user ? <ProfileContent /> : <AuthenticationPage />
        )}
      </div>
    </Layout>
  );
};

export default Profile;
